import {
  booleanAttribute,
  Component,
  Input,
  numberAttribute,
} from "@angular/core";

export type IconType =
  | "bubble-smile"
  | "menu"
  | "leaves"
  | "check"
  | "dots"
  | "heart"
  | "heart-file"
  | "house"
  | "suit-case"
  | "calendar"
  | "favorite"
  | "favorite-outline"
  | "user"
  | "user-profile-right"
  | "users"
  | "building"
  | "smile"
  | "check-dot"
  | "info"
  | "danger"
  | "bell"
  | "clock"
  | "play"
  | "email"
  | "lock"
  | "search"
  | "phone"
  | "chart"
  | "power"
  | "parameters"
  | "crawn"
  | "gauge"
  | "edit"
  | "arrow-left"
  | "arrow-right"
  | "arrow-down"
  | "chevron-left"
  | "chevron-down"
  | "chevron-right"
  | "chevron-up"
  | "close"
  | "trash"
  | "add"
  | "exchange"
  | "upload"
  | "filter"
  | "eye-open"
  | "eye-closed"
  | "options"
  | "trash-primary"
  | "sad-emoji"
  | "woozy-emoji"
  | "neutral-emoji"
  | "happy-emoji"
  | "laughy-emoji"
  | "award-prize"
  | "hands-heart"
  | "pdf"
  | "file"
  | "candle"
  | "house-rustic"
  | "storm"
  | "diagonal-arrow"
  | "heart-hand"
  | "telescope"
  | "play-button"
  | "thumb-like-active"
  | "thumb-like-inactive"
  | "thumb-dislike-active"
  | "thumb-dislike-inactive"
  | "clock-circle"
  | "next"
  | "previous"
  | "play-filled"
  | "speaker"
  | "pause"
  | "speaker-muted"
  | "forward"
  | "backward"
  | "play-rectangle-fill"
  | "file-content"
  | "play-contain"
  | "export"
  | "download"
  | "manage"
  | "trust"
  | "question"
  | "question-mark"
  | "road"
  | "trainer"
  | "video-conference"
  | "onboarding-chart"
  | "onboarding-rain"
  | "onboarding-question"
  | "onboarding-chatting"
  | "onboarding-citation"
  | "heart-square"
  | "visio-conference"
  | "combined-graphic"
  | "calendar-variant"
  | "haltere"
  | "save"
  | "favorite-badge"
  | "thin-favorite"
  | "thin-filled-favorite"
  | "education"
  

@Component({
  selector: "app-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
})
export class IconComponent {
  @Input() type!: IconType;

  @Input({ transform: booleanAttribute }) button: boolean = false;

  @Input({ transform: numberAttribute }) size?: number;

  @Input() color?: string;

  getSvgFile(type: IconType): string {
    return `assets/icons/${type}.svg`;
  }
}
